import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import { transactionHistory, withdrawableTransactions } from '../../Services/DashboardServices';

const columns = [
    { name: 'Order ID', selector: row => row.order_id, width: '10%' },
    { name: 'Amount', selector: row => row.amount, width: '10%' },
    { name: 'Withdrawable In', selector: row => row.withdrawable_in, width: '15%' },
    { name: 'Created At', selector: row => row.created_at.split("T")[0], width: '10%' },
    // { name: 'Payment Type', selector: row => row.payment_type },
    { name: 'Description', selector: row => row.description, width: '55%' },
    // { name: 'Status', selector: row => row.status },
];

const RefferalAndEarning = () => {
    const [data, setData] = useState([]);
    const [filterText, setFilterText] = useState('');
    const [filteredData, setFilteredData] = useState([]);
    const [loading, setLoading] = useState(true);

    const handleGetTransaction = async () => {
        setLoading(true);
        try {
            const response = await transactionHistory(startDate, endDate);
            setData(response?.result?.transactions?.original?.data || []);
            setLoading(false);
        } catch (err) {
            console.error("Error fetching transaction history", err);
        }
    };

    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");

    const handleStartDate = (e) => setStartDate(e.target.value);
    const handleEndDate = (e) => setEndDate(e.target.value);


    useEffect(() => {
        handleGetTransaction();
    }, [startDate, endDate]);

    useEffect(() => {
        const filtered = data.filter(item =>
            Object.values(item).some(value =>
                String(value).toLowerCase().includes(filterText.toLowerCase())
            )
        );
        setFilteredData(filtered);
    }, [filterText, data]);

    return (
        <div>


            <h3 className='fw-bold mb-0'>Refferal and Earning</h3>
            <p>
                All refferal and earnings
            </p>

            <div className='row justify-content-end mb-3'>

                <div className="col-auto">
                    <label className='fw-bold s-12'>Start Date</label>
                    <input value={startDate} onChange={handleStartDate} type="date" className='form-control' />
                </div>
                <div className="col-auto">
                    <label className='fw-bold s-12'>End Date</label>
                    <input value={endDate} onChange={handleEndDate} type="date" className='form-control' />
                </div>
                <div className='col-auto d-flex flex-column justify-content-end'>
                    <label className='fw-bold s-12'>Search</label>
                    <input
                        className='form-control'
                        type="text"
                        placeholder="Search..."
                        value={filterText}
                        onChange={e => setFilterText(e.target.value)}

                    />
                </div>
            </div>

            {loading ? (
                <div style={{ textAlign: 'center', padding: '50px' }}>
                    <div className="spinner-border text-info" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            ) : (
                <DataTable
                    columns={columns}
                    data={filteredData}
                    pagination
                    highlightOnHover
                    striped
                />
            )}
        </div>
    );
};

export default RefferalAndEarning;
